import * as analytics from 'lib/analytics'

const handleFulltextClick = ({ doi, memberId, issns = [], partnerName = undefined }) => {
  if (partnerName) {
    analytics.event({
      category: 'Report',
      action: 'Clicked full text link',
      label: `partnerName:${partnerName}`
    })
  }
  analytics.event({
    category: 'Report',
    action: 'Clicked full text link',
    label: `doi:${doi}`
  })
  analytics.event({
    category: 'Report',
    action: 'Clicked full text link',
    label: `m_id:${memberId}`
  })
  for (const issn of (issns || [])) {
    analytics.event({
      category: 'Report',
      action: 'Clicked full text link',
      label: `issn:${issn}`
    })
  }
}
export default handleFulltextClick
